import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
});

export const submitQuote = (payload) => api.post("/quotes", payload).then((r) => r.data);
export const fetchDemoAnalytics = () => api.get("/analytics/demo").then((r) => r.data);

export const adminLogin = (password) =>
  api.post("/admin/login", { password }).then((r) => r.data);

export const fetchLeads = (token) =>
  api.get("/admin/quotes", { headers: { "X-Admin-Token": token } }).then((r) => r.data);

export const updateLeadStatus = (id, status, token) =>
  api
    .patch(
      `/admin/quotes/${id}`,
      { status },
      { headers: { "X-Admin-Token": token } }
    )
    .then((r) => r.data);
